// ESLint Global var declaration
/* global TweenMax, Back */

export default class Cloud {

  constructor(options) {

    this.options = options || {};

    this.stopped = true;
    this.dim = { x:246, y:140 };
    this.cloud = $('<div class="sprite cloud"></div>');
    this.scale = this.getScale();
    this.pos = this.getPosition(0, this.options.maxW);
    this.trans = { x:0, y:0 };
    this.speed = this.getSpeed();
    this.ampliude = this.getRangomRange(5, 20);
    this.degrees = this.getRangomRange(0, 360);

    this.cloud.css({
      width:this.dim.x * this.scale,
      height:this.dim.y * this.scale,
      left:this.pos.x,
      top:this.pos.y,
    });

  }

  restart() {

    this.cloud.css('transform', 'translate3d(0,0,0)');
    this.trans = { x: 0, y: 0 };

    this.scale = this.getScale();
    this.pos = this.getPosition( ( this.options.maxW * 0.8 ), ( this.options.maxW * 1.2 ) );

    this.cloud.css({
      width:this.dim.x * this.scale,
      height:this.dim.y * this.scale,
      left:this.pos.x,
      top:this.pos.y,
    });

    this.reveal();
  }

  getPosition( minX, maxX ) {
    const maxY = this.options.maxH;

    return {
      x: this.getRangomRange(minX, maxX),
      y: this.getRangomRange(0, maxY),
    };
  }

  getSpeed() {
    const max = 100;
    const min = 10;
    return ( this.getRangomRange(min, max) ) / 100;
  }

  getScale() {
    const max = 90;
    const min = 20;
    return ( this.getRangomRange(min, max) ) / 100;
  }

  getRangomRange(min, max) {
    return Math.random() * ( (max - min) + min );
  }

  reveal() {
    const delay = ( this.getRangomRange(20, 150) ) / 100;
    const time = ( this.getRangomRange(30, 50) ) / 100;
    const opacity = ( this.getRangomRange(30, 80) ) / 100;
    const that = this;

    this.stopped = false;

    TweenMax.fromTo(
      this.cloud,
      time,
      { scale:0 },
      { scale:1, opacity, delay, ease: Back.easeOut, onComplete() { that.start(); } }
    );

  }

  start() {
    // console.log('STARTED CLOUD');
    this.stopped = false;
    this.updateUI();
  }

  stop() {
    this.stopped = true;
  }

  updateUI() {

    if ( !this.stopped ) {

      // animate
      this.trans.x -= ( this.speed * this.scale );

      this.degrees += 1;

      if ( this.degrees > 360 ) {
        this.degrees = 0;
      }

      this.trans.y = ( this.ampliude * Math.sin( this.degrees * (Math.PI / 180) ) );

      this.cloud.css( 'transform', `translate3d(${this.trans.x}px, ${this.trans.y}px,0)` );

      // test if onscreen
      if ( this.pos.x + this.trans.x + this.cloud.width() < 0 ) {
        this.stopped = true;
        this.cloud.css('opacity', '0');
      } else {
        window.requestAnimationFrame( () => this.updateUI() );
      }

    }

  }

  handleResize() {

  }

  handleScroll() {

  }

}




// WEBPACK FOOTER //
// ./js/controllers/modules/Cloud.js